module.exports = __webpack_public_path__ + "static/calatonSystemsMobile@2x-296311bad37bb90469b9641389af534e.jpg";